import React from 'react';

const ActiveTickIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M18.4458 5.39691C18.7789 5.64312 18.8493 6.11274 18.6031 6.44584L10.7933 17.012C10.1574 17.8724 8.90512 17.9658 8.14858 17.2093L4.46967 13.5304C4.17677 13.2375 4.17677 12.7626 4.46967 12.4697C4.76256 12.1768 5.23743 12.1768 5.53033 12.4697L9.20925 16.1486C9.31732 16.2567 9.49622 16.2434 9.58706 16.1205L17.3969 5.55425C17.6431 5.22115 18.1127 5.15071 18.4458 5.39691Z" fill="#2FDBA1" />
  </svg>
);

export default ActiveTickIcon;
